import moment from 'moment'

export const getters = {
	isUser: state => (state.token !== null),
	isAuthenticated: state => (state.token !== null),
	offices: state => (state) ? state.offices : null,
	user: state => state,
	getClients: state => state.clients,
	getClient: state => id => {
		// Le store est persisté en localStorage : on ignore les entrées nulles ou invalides
		// pour éviter un "Cannot read properties of null (reading 'id')" pendant le rendu
		const clients = Array.isArray(state.clients) ? state.clients : []
		const contact = clients.find(contact => contact && parseInt(contact.id) === parseInt(id))
		return contact || null
	},
	isTokenExpired: (state) => state.token_duration && moment(state.token_duration) <= moment(),
	isAnonymous: state => (state.role === 'ANONYMOUS'),
	isEstate: state => state.isEstate,
	isForceCompleteProfile: state => false,
	tokenDuration: state => state.token_duration,
	client_next_rdv: (state) => typeof state.client_next_rdv !== 'undefined' ? state.client_next_rdv : null

}



// WEBPACK FOOTER //
// ./src/store/modules/Users/getters.js